import React from 'react'
import styles from './Divider.module.scss'

export const Divider = () => <div className={styles.Divider} />
